const getServiceHubData = () => {
  // Check if we are in a browser environment
  if (typeof window === "undefined") {
    return null; // Return null or a default object if running on the server
  }

  const serviceHubData = localStorage.getItem("serviceHub");

  if (!serviceHubData) {
    // console.warn("No serviceHub found in local storage.");
    return null; // Return null if not found
  }

  try {
    return JSON.parse(atob(serviceHubData));
  } catch (error) {
    console.error("Failed to parse serviceHub:", error);
    return null; // Return null on parsing error
  }
};

export const getCurrencyCode = () => {
  try {
    const serviceHub = getServiceHubData();
    if (serviceHub && serviceHub.countryCurrencyName) {
      const currencySymbol = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: serviceHub.countryCurrencyName,
      }).format(0); // Format a value (e.g., 0) just to get the symbol
      const symbol = currencySymbol.replace(/[0-9.,\s]/g, "").trim();
      return symbol;
    }
    return "₹";
  } catch (error) {
    console.error("Error fetching currency code", error);
    return "₹";
  }
};

export const getHubId = () => {
  const serviceHub = getServiceHubData();
  return serviceHub?.id || 31; // Return hub ID or default (31)
};
